export default {
  labels: {
    custom: 'Personnalisé - Disponible sur demande',
    was: 'Était {{amount}} – remise annuelle appliquée',
  },
  tags: {
    preferred: 'Particulièrement populaire',
    net_one_time: 'net unique',
    annual_discount: '-{{percentage}}% annuel',
  },
  buttons: {
    select_plan: 'Choisir ce plan',
  },
};
